import React from 'react';
import { useMutation } from '@apollo/client';
import { SessionActions } from '../../account/sessionSlice';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import { gql } from '../../graphql/generated/gql';
import TeamIcon from '../../organization/TeamIcon';
import SettingsImageEditor from '../../settings/SettingsImageEditor';
import * as styles from './TeamIconEditor.module.scss';

interface TeamIconEditorProps {
  size?: React.ComponentProps<typeof TeamIcon>['size'];
}

const UPDATE_ORGANIZATION_LOGO_MUTATION = gql(/** @complexity 4 */ `
  mutation updateOrganizationLogo($logo: Upload) {
    organization: updateOrganization(logo: $logo) {
      id
      logo {
        original
        thumb
      }
    }
  }
`);

const TeamIconEditor = ({ size = 'xlarge' }: TeamIconEditorProps) => {
  const dispatch = useAppDispatch();
  const [updateLogo] = useMutation(UPDATE_ORGANIZATION_LOGO_MUTATION);

  const handleUpload = (logo: File) =>
    updateLogo({ variables: { logo } }).then(({ data }) => {
      if (data) {
        dispatch(
          SessionActions.setCurrentOrganization({
            logo: data.organization.logo,
          }),
        );
      }
    });

  return (
    <SettingsImageEditor onUpload={handleUpload}>
      <h5 className={styles.label}>Team logo</h5>
      <TeamIcon size={size} />
    </SettingsImageEditor>
  );
};

export default TeamIconEditor;
